import React from 'react';
import { cn } from '../../lib/utils';

export const Badge = ({ className, variant = 'default', ...props }) => {
  const variants = {
    default: "bg-indigo-100 text-indigo-800 hover:bg-indigo-200",
    secondary: "bg-slate-100 text-slate-800 hover:bg-slate-200",
    outline: "border border-slate-200 text-slate-800",
    destructive: "bg-red-100 text-red-800 hover:bg-red-200",
    success: "bg-green-100 text-green-800 hover:bg-green-200",
  };
  return (
    <span className={cn(
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors",
      variants[variant],
      className
    )} {...props} />
  );
};
